import React, { useCallback } from 'react';
import { GestureResponderEvent, Pressable, StyleSheet } from 'react-native';
import { DNABox, DNAText } from '@alucio/lux-ui';
import colors from '@alucio/lux-ui/src/theming/themes/alucio/colors';
import { CrmSyncStatus } from '@alucio/aws-beacon-amplify/src/models';
import { MeetingORM } from 'src/types/types';
import { useUserTenant } from 'src/state/redux/selector/user';
import { useCRMStatus } from 'src/hooks/useCRMStatus';
import { getCrmRecordUrl } from './utils/getCrmRecordUrl';

const S = StyleSheet.create({
  linkText: {
    textDecorationLine: 'underline',
    color: colors['color-primary-600'],
  },
});

interface CrmIdCellProps {
  meetingORM: MeetingORM;
}

const CrmIdCell: React.FC<CrmIdCellProps> = ({ meetingORM }) => {
  const tenant = useUserTenant();
  const { crmIntegrationType } = useCRMStatus();
  const crmRecord = meetingORM.model.crmRecord;
  const crmCallId = crmRecord?.crmCallId;
  const displayName = crmRecord?.crmCallName || crmCallId;
  const instanceUrl = tenant?.config.crmIntegration?.instanceUrl;
  const isDeleted = crmRecord?.crmSyncStatus === CrmSyncStatus.DELETED;
  const isLinkable = !!instanceUrl && !!crmCallId && !isDeleted;

  const onPress = useCallback(
    (e: GestureResponderEvent) => {
      e.stopPropagation();
      if (isLinkable) {
        const url = getCrmRecordUrl(instanceUrl!, crmCallId!, crmIntegrationType);
        window.open(url, '_blank');
      }
    },
    [isLinkable, instanceUrl, crmCallId, crmIntegrationType],
  );

  if (!displayName) {
    return <DNABox fill />;
  }

  return (
    <DNABox appearance="col" fill alignX="start">
      <Pressable onPress={onPress} disabled={!isLinkable}>
        <DNAText style={isLinkable ? S.linkText : undefined} numberOfLines={1}>
          {displayName}
        </DNAText>
      </Pressable>
    </DNABox>
  );
};

export default CrmIdCell;
